var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17C20.3409 17 21.8333 15.5076 21.8333 13.6667C21.8333 11.8257 20.3409 10.3333 18.5 10.3333C16.659 10.3333 15.1666 11.8257 15.1666 13.6667C15.1666 15.5076 16.659 17 18.5 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.6667C18.5 23.6667 25.1667 23.6667 25.1667 22C25.1667 20 21.9167 17.8333 18.5 17.8333C15.0834 17.8333 11.8334 20 11.8334 22C11.8334 23.6667 18.5 23.6667 18.5 23.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.3333V12.8333H9.33337V15.3333H6.83337V17H9.33337V19.5H11V17H13.5V15.3333H11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7db6922768ed13ec4c837cc249b3bc75.svg";
export { ForwardRef as ReactComponent };